import React from 'react'
import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { InactiveAi360LabelIcon } from 'src/Elements/LiveView/AlternativeView/InactiveAi360LabelIcon'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  cx: number
  cy: number
}

const InactiveView: React.FC<Props> = ({ cx, cy }) => {
  const theme = useTheme()
  const upSm = useMediaQuery(theme.breakpoints.up('sm'))
  const { t } = useCustomTranslation()

  return (
    <>
      <g transform={`translate(${upSm ? 35 : 30}, ${cy - 25})`}>
        <InactiveAi360LabelIcon style={{ color: theme.palette.grey.grey05 }} />
      </g>
      <Stack component="text" textAnchor="middle" x={cx - 5} y={cy + 20}>
        <Typography component="tspan" x={cx} variant="h3" alignSelf="center" fill={theme.palette.grey.grey05}>
          {t('chart.pie-chart.inactive-view.label')}
        </Typography>
      </Stack>
    </>
  )
}

export default InactiveView
